import { colorsDark } from './dark';
import { colorsLight } from './light';

export const colors = {
  light: colorsLight,
  dark: colorsDark,
};
